import { AppBar, Box, Button, Container, Toolbar, Typography } from "@mui/material";
import { Link as RouterLink, Outlet, useNavigate } from "react-router-dom";
import { useAdminAuth } from "../../app/AdminAuthContext";

const navItems = [
  { label: "Behandlinger", path: "/admin/treatments" },
  { label: "Ansatte", path: "/admin/staff" },
  { label: "Høreapparat-leverandører", path: "/admin/hearing-aid-suppliers" },
  { label: "Timeinfo", path: "/admin/appointment-info" },
  { label: "Sidetekster", path: "/admin/site-content" },
];

export default function AdminLayout() {
  const { logout } = useAdminAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/admin/login");
  };

  return (
    <Box>
      <AppBar position="static" sx={{ backgroundColor: "secondary.main" }}>
        <Toolbar sx={{ gap: 1, flexWrap: "wrap", py: 1 }}>
          <Typography variant="h6" sx={{ mr: 2 }}>
            Admin
          </Typography>
          {navItems.map((item) => (
            <Button
              key={item.path}
              component={RouterLink}
              to={item.path}
              sx={{ color: "common.white" }}
            >
              {item.label}
            </Button>
          ))}
          <Box sx={{ flexGrow: 1 }} />
          <Button onClick={handleLogout} sx={{ color: "common.white" }}>
            Logg ut
          </Button>
        </Toolbar>
      </AppBar>
      <Container sx={{ py: 4 }}>
        <Outlet />
      </Container>
    </Box>
  );
}
